import { Model } from '@vuex-orm/core'
import moment from 'moment'
import Task from './Task'
import Vacation from './Vacation'

export default class User extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'users'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(''),
      first_name: this.attr(''),
      surname: this.attr(''),
      department_id: this.attr(null),
      trafficable: this.boolean(true),
      administration: this.boolean(false),
      supervisor: this.boolean(false),
      tasks: this.hasMany(Task, 'assigned_to_id'),
      vacations: this.hasMany(Vacation, 'user_id'),
      avatar: this.attr(''),
      sort: this.attr(0),
    }
  }

  getTasksByDay(day) {
    return Task.query()
               .where(record => record.id > 0)
               .where('assigned_to_id', this.id)
               .where('starts_at', value => value.match(new RegExp('^'+moment(day).startOf('day').format('YYYY-MM-DD '))))
               .orderBy('starts_at')
               .get()
  }

  getTaskInHour(hour) {
    return Task.query()
               .where('assigned_to_id', this.id)
               .where('starts_at', moment(hour).format('YYYY-MM-DD HH:mm:ss'))
               .orderBy('starts_at')
               .get()
  }

  hasVacation(day) {
    day = moment(day).format('YYYY-MM-DD')
    const query = Vacation.query().where('user_id', this.id)
                                  .where('starts_at', value => value <= day)
                                  .where('ends_at', value => value >= day)
    return query.count() > 0
  }

  get creative() {
    return this.department_id == 1
  }

  get icon() {
    return 'mdi-account'
  }

  get model() {
    return 'user'
  }

  get name() {
    return this._name || `${this.first_name}${this.surname[0]}`
  }

  set name(name) {
    this._name = name
  }

  get treeId() {
    return 'user-'+this.id
  }
}